import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getTablets(params) {
    return api.get(ENDPOINTS.TABLETS.BASE, { params });
}
export function getTablet(id) {
    return api.get(ENDPOINTS.TABLETS.BY_ID(id));
}
export function createTablet(payload) {
    return api.post(ENDPOINTS.TABLETS.BASE, payload);
}
export function updateTablet(id, payload) {
    return api.patch(ENDPOINTS.TABLETS.BY_ID(id), payload);
}
export function deleteTablet(id) {
    return api.delete(ENDPOINTS.TABLETS.BY_ID(id));
}
